import { DepositLocation } from '@varo/graphql-schema-types';
import { TFunction } from 'i18next';
import { TagType } from 'shared/components/vxl/Tag/Tag';

interface FeeDisplay {
  text: string;
  type: TagType;
}

interface DepositLocationWithFee extends Pick<DepositLocation, 'id' | 'name'> {
  customerFee?: number | null;
  isFreeCashDepositLocation?: boolean;
}

export const useFeeDisplay = (
  marker: DepositLocationWithFee | null,
  translatedText: TFunction,
): FeeDisplay | null => {
  if (!marker) {
    return null;
  }

  const { customerFee, isFreeCashDepositLocation } = marker;

  if (
    customerFee === null ||
    customerFee === undefined ||
    !Number.isFinite(customerFee)
  ) {
    return null;
  }

  const rounded = Math.round(customerFee * 100) / 100;

  const isFree = isFreeCashDepositLocation || rounded === 0;
  const formattedFee = new Intl.NumberFormat(undefined, {
    currency: 'USD',
    style: 'currency',
  }).format(rounded);

  return {
    text: isFree ? translatedText('maps.noFee') : formattedFee,
    type: isFree ? TagType.HIGHLIGHT : TagType.INFO,
  };
};
